/*
 * Copyright ish group pty ltd. All rights reserved. https://www.ish.com.au
 * No copying or use of this code is allowed without permission in writing from ish.
 */

import { PortalWebsite } from '@api/model';
import { IAction } from '../../models/IshAction';
import { GET_PORTAL_WEBSITES_FULFILLED } from 'src/js/redux/actions/PortalWebsite';

export const portslWebsiteReducer = (state: PortalWebsite[] = [], action: IAction): PortalWebsite[] => {
  switch (action.type) {
    case GET_PORTAL_WEBSITES_FULFILLED:
      return action.payload;
    default:
      return state;
  }
};